﻿import type {
    RebindAsyncTypeControl,
    RebindDataSourceTypeControl,
    SelectControl
} from '../types/utils/rebind-data-source';

function rebindDataSource(control: RebindDataSourceTypeControl | undefined) {
    if (!control) {
        console.warn('Rebinding failed, control not found');
        return;
    }
    if (control instanceof kendo.ui.Gantt) {
        control.dataSource.read();
        control.dependencies.read();
        return;
    }

    if (control instanceof kendo.ui.Scheduler) {
        control.resources.forEach((resource: kendo.ui.SchedulerResource) => void resource.dataSource.read());
        control.dataSource.read();
        return;
    }

    control.dataSource.read();
}

function rebindAsync(instance: RebindAsyncTypeControl) {
    return new Promise((resolve) => {
        instance.dataSource.read().done(resolve);
    });
}

/**
 * Привязывает обработчик к элементу управления Kendo ComboBox или MultiSelect,
 * чтобы при первом открытии выпадающего списка происходило обновление источника данных.
 *
 * В попапах достаточно передать ID элемента управления,
 * на страницах можно передать готовый инстанс ComboBox или MultiSelect.
 *
 * @param control - ID элемента управления (строка) или экземпляр ComboBox/MultiSelect.
 * */
function rebindOnFirstOpenSelect(control: string | SelectControl | undefined) {
    let instance: SelectControl | undefined;

    if (typeof control === 'string') {
        const element = $(`#${control}`);

        if (element.length === 0) {
            console.warn(`Element with ID '${control}' not found`);
            return;
        }

        // '.kendoCombobox' or '.kendoMultiSelect'
        const handlerData = element.data().handler;
        if (!handlerData || !handlerData.ns) {
            console.warn(`Control '${control}' is not initialized or handler data is missing`);
            return;
        }

        const typeInstance = handlerData.ns.replace('.', '');
        instance = element.data(typeInstance);

        if (!instance) {
            console.warn(`Control '${control}' instance not found`);
            return;
        }
    }
    else {
        instance = control;
    }

    instance?.one('open', () => {
        rebindDataSource(instance);
    });
}

/**
 * Сохраняет правки грида (например, собранные в режиме InCell) и по завершении сохранения перечитывает данные.
 *
 * Перечитыку нельзя делать до завершения `sync()`: `read()` затрёт несохранённые правки.
 * При ошибке сохранения перечитка не выполняется — причина показывается обработчиками самого грида.
 *
 * @param control - грид (или другой контрол с DataSource), который нужно сохранить и перечитать.
 * */
function syncAndRebind(control: RebindDataSourceTypeControl | undefined): Promise<void> {
    if (!control) {
        console.warn('syncAndRebind failed, control not found');
        return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
        control.dataSource.sync()
            .done(() => {
                rebindDataSource(control);
                resolve();
            })
            .fail((error: unknown) => {
                console.error('syncAndRebind: sync failed', error);
                resolve();
            });
    });
}

window.rebindAsync = rebindAsync;
window.rebindDataSource = rebindDataSource;
window.rebindOnFirstOpenSelect = rebindOnFirstOpenSelect;
window.syncAndRebind = syncAndRebind;